import { Loader } from '@rsos/base-components';
import { IntermediateWrapper } from './index.styles';

const TableLoading = ({ height }: { height?: number }) => (
  <IntermediateWrapper height={height}>
    <Loader />
  </IntermediateWrapper>
);

export default TableLoading;
